module.exports = __webpack_public_path__ + "static/venti-button-9b8ced731bc5f813367516c2a2f665cf.png";